import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

// ช่องทาง Delivery — master CRUD + price book (docs/delivery-platform-pricing.md ฝั่ง api)
class DeliveryPlatformsApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}


	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/delivery-platforms/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}


	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/delivery-platforms/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/delivery-platforms/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// price book — branch_id ไม่ส่ง = ราคากลาง (branch NULL) / ส่ง = exception รายสาขา
	async getProducts(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms/' + id + '/products' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// items: [{product_id, price}] — price = null ลบแถว (กลับไปใช้ราคาหน้าร้าน)
	async updateProducts(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/delivery-platforms/' + id + '/products' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// manage branches — เปิด/ปิด + GP override รายสาขา จากฝั่ง platform
	async getBranches(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms/' + id + '/branches' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateBranches(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/delivery-platforms/' + id + '/branches' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// ===== P2 รับเงิน platform (settlements) =====
	// บิล platform_pending ที่รอเคลียร์ + ยอดคาดรับ
	async settlementPending(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms/' + id + '/settlements/pending' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async settlements(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/delivery-platforms/' + id + '/settlements' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// สร้างรอบรับเงิน — บิลทั้งชุด flip platform_pending → paid
	async createSettlement(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/delivery-platforms/' + id + '/settlements' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// ยกเลิกรอบ (บันทึกผิด) — บิลกลับเป็น platform_pending
	async voidSettlement(id, settlementId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/delivery-platforms/' + id + '/settlements/' + settlementId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const DeliveryPlatforms = new DeliveryPlatformsApi();
